document.addEventListener('DOMContentLoaded', function () {
    // Seleciona todos os containers de scroll
    const scrollContainers = document.querySelectorAll('.scroll-container');

    scrollContainers.forEach(scrollContainer => {
        const scrollContent = scrollContainer.querySelector('.scroll-content');
        const scrollBar = scrollContainer.querySelector('.scroll-bar');
        const scrollThumb = scrollContainer.querySelector('.scroll-thumb');

        // Atualiza o tamanho do thumb
        function updateThumbSize() {
            const ratio = scrollContainer.clientWidth / scrollContent.scrollWidth;
            scrollThumb.style.width = `${ratio * scrollBar.clientWidth}px`;
        }

        // Atualiza a posição do thumb com base no scroll
        function updateThumbPosition() {
            const scrollRatio = scrollContent.scrollLeft / (scrollContent.scrollWidth - scrollContainer.clientWidth);
            const thumbMax = scrollBar.clientWidth - scrollThumb.offsetWidth;
            scrollThumb.style.left = `${scrollRatio * thumbMax}px`;
        }

        // Listener para scroll no conteúdo
        scrollContent.addEventListener('scroll', () => {
            updateThumbPosition();
        });

        // Atualiza a barra ao redimensionar a janela
        window.addEventListener('resize', () => {
            if (scrollContent.scrollWidth > scrollContent.clientWidth) {
                scrollBar.classList.add('scroll-active');
            } else {
                scrollBar.classList.remove('scroll-active');
            }
            updateThumbSize();
            updateThumbPosition();
        });

        // Inicializa o tamanho e posição do thumb
        if (scrollContent.scrollWidth > scrollContent.clientWidth) {
            scrollBar.classList.add('scroll-active');
        } else {
            scrollBar.classList.remove('scroll-active');
        }
        updateThumbSize();
        updateThumbPosition();
    });
});
